import { DictionaryItem, Entity } from '@hglobal/common';
import { User } from '@pt/models';

export enum TransactionDirection {
  Income = 'income',
  Expense = 'expense',
}

export enum TransactionChartType {
  Income = 'income',
  Expense = 'expense',
  IncomeExpense = 'incomeExpense',
  ReceivedSent = 'receivedSent',
  ReceivedBurned = 'receivedBurned',
}

export interface Transaction extends Entity {
  metric: string;
  sum: number;
  createdAt: string;
  comment: string | null;
  user: User | null;
}

export interface TransactionMetric extends DictionaryItem<string> {
  label: string;
  direction: TransactionDirection;
}

export interface TransactionMetricTotal extends Entity<string> {
  amount: number;
}

export interface TransactionChart extends Entity<TransactionChartType> {
  metrics: TransactionMetricTotal[];
}

// export enum TransactionStatus {
//   // Income group
//   Reward = 'reward',
//   FuncReward = 'funcReward',
//   FromColleague = 'fromColleague',
//   Refund = 'refund', // Expense group
//   Purchase = 'purchase',
//   ToColleague = 'toColleague',
//   Rollback = 'rollback', // Team bonus group
//   Sent = 'sent',
//   Received = 'received',
//   Burned = 'burned',
// }
